export default __webpack_public_path__ + "static/media/robot-medal.c7195862.png";